import * as React from 'react'
import { TextWithHorizontalLine } from 'uiComponents/pageElements'
import '../capacitySection.scss'
import { useTranslation } from 'translations'

interface CapacitySectionShellProps {
    capacities: React.ReactNode
    timeSlots: React.ReactNode
    timeSlotsControl?: React.ReactNode
}

export function CapacitySectionShell({ capacities, timeSlots, timeSlotsControl }: CapacitySectionShellProps) {
    const { t } = useTranslation()
    return (
        <>
            <TextWithHorizontalLine
                style={{ marginTop: '0.8rem', marginBottom: '1rem' }}
                text={t('capacity.formSection.heading').toUpperCase()}
                alignment="left"
            />
            <div className="capacity-section">
                <div className="capacity-section-part">
                    <h4 className="capacity-section-heading">{t('capacity.formSection.capacities')}</h4>
                    <div className="capacity-section-list">{capacities}</div>
                </div>
                <div className="capacity-section-part">
                    <h4 className="capacity-section-heading">{t('capacity.formSection.timeSlots')}</h4>
                    {timeSlotsControl}
                    {timeSlots}
                </div>
            </div>
        </>
    )
}
